module.exports = __webpack_public_path__ + "static/media/user-avatar-settings.df9f580d.svg";